'use strict';

/**
 * View for rendering a single set in the select/update set modal
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/share-columns-list-item.hbs');

var ShareColumnsListItemView = ColidoItemView.extend({
    template: template,

    tagName: 'li',

    ui: {
        checkbox: '[type="checkbox"]',
    },

    triggers: {
        'change @ui.checkbox': 'item:toggled',
    },
});

module.exports = ShareColumnsListItemView;